<script>
import { getOrderStatus } from "@/http/api/order";
import { getRechargeStatus } from "@/http/api/member";
import { orderListPath } from './order-list-route';


export default {
  name: "PaySuccessView",
  props: {
    order_no: {
      type: String,
      default: ''
    },
    recharge_no: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      countdown: 10, // 倒计时10秒
      timer: null,
      checkTimer: null,
      handleSuccess: false,
      checkInterval: 5000,
      orderType: 2
    }
  },
  mounted() {
    this.startCheckingPaymentStatus();
  },
  methods:{
    startCheckingPaymentStatus() {
      this.checkTimer = setInterval(() => {
        this.checkPaymentStatus();
      }, this.checkInterval);
    },
    async checkPaymentStatus() {
      // console.log('Checking payment status...');

      if (this.recharge_no != '') {
        await getRechargeStatus({orderNo: this.recharge_no}).then(res => {
          // console.log('Payment status:', res.data);
          if (res.data?.pay_status === '2' && this.handleSuccess === false) {
            clearInterval(this.checkTimer);
            this.handleSuccess = true;
            this.startCountdown();
          }
        }).catch(e => {
          console.error('Failed to check payment status:', e);
          this.$message.error(e.message ?? e.msg ?? this.$t("pay_success_view.message.check_recharge_error"));
        });
      } else {
        await getOrderStatus({orderNo: this.order_no}).then(res => {
          // console.log('Payment status:', res.data);
          if (res.data?.pay_status === '2' && this.handleSuccess === false) {
            clearInterval(this.checkTimer);
            this.orderType = res.data?.type ?? 2
            this.handleSuccess = true;
            this.startCountdown();
          }
        }).catch(e => {
          console.error('Failed to check payment status:', e);
          this.$message.error(e.message ?? e.msg ?? this.$t("pay_success_view.message.check_order_error"));
        });
      }
      
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.handleViewOrderNow();
        }
      }, 1000);
    },
    handleViewOrderNow(){
      clearInterval(this.timer);

      // console.log('close')
      this.$emit('close')

      if (this.recharge_no != '') {
        this.$router.replace({path: '/ucenter/wallet/', query: {orderNo: this.recharge_no}}).catch(() => {});
      } else {
        this.$router.replace({path: orderListPath(this.orderType), query: {orderNo: this.order_no}}).catch(() => {});
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.checkTimer);
  }
}
</script>

<template>
  <div class="payment-success-overlay flex justify-center items-center">
    <div v-if="!handleSuccess" class="checking-status">
      <div class="flex flex-col justify-center items-center text-[50px] leading-[100px] text-slate-600 dark:text-neutral-300 font-bold">
        <p>{{ $t("cpts.pay_success_view.guide.p1") }}<span class="ml-8">{{ $t("cpts.pay_success_view.guide.p2") }}</span></p>
        <p class="text-animate">{{ $t("cpts.pay_success_view.status.checking") }}</p>
      </div>
    </div>
    <div v-else class="flex flex-row justify-center items-center">
      <img class="succ-img" src="@/assets/index/img/pay/succ.png" alt="">

      <div class="text-[50px] leading-[100px] text-slate-600 dark:text-neutral-300 font-bold">
        <div>
            <p>{{ $t("cpts.pay_success_view.status.success") }}</p>
            <p class="text-animate">{{ $t("cpts.pay_success_view.instruction", {countdown: countdown}) }}</p>
        </div>
        <div class="mt-[30px] pt-[5px] text-right">
          <a @click.prevent="handleViewOrderNow" href="javascript:void(0);" class="text-[#007aff]">{{ $t("cpts.pay_success_view.go") }} 
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block">
              <path d="M0.0902161 9.58947L16.7281 9.58947" stroke="#F8F7FF" stroke-width="2"/>
              <path d="M8.5 1L16.9998 9.49981L8.5 17.9996" stroke="#F8F7FF" stroke-width="2"/>
            </svg>
          </a>          
        </div>
      </div>
      
    </div>
  </div>
</template>

<style scoped>
.payment-success-overlay {
  position: fixed;
  inset: 0;
  z-index: 1501;
  overflow-y: auto;
  background-color: rgba(246, 245, 255, 0.94);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}

@media (prefers-color-scheme: dark) {
  .payment-success-overlay {
    background-color: rgba(0, 0, 0, 0.9);
  }
}
</style>
